import { render, staticRenderFns } from "./Personalcenters.vue?vue&type=template&id=2906c7b8&scoped=true&"
import script from "./Personalcenters.vue?vue&type=script&lang=js&"
export * from "./Personalcenters.vue?vue&type=script&lang=js&"
import style0 from "./Personalcenters.vue?vue&type=style&index=0&id=2906c7b8&scoped=true&lang=css&"
import style1 from "./Personalcenters.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2906c7b8",
  null
  
)

export default component.exports